import { useAntdTable } from 'ahooks';
import { AntdTableResult } from 'ahooks/lib/useAntdTable/types';
import { noDataFilter } from '@/utils/tool';
import { Form } from 'antd';
type Service = (params: any) => Promise<any>;
interface OptionsProps {
  [name: string]: any;
}

interface Result {
  total: number;
  list: any[];
}
export function useList(service: Service, options: OptionsProps): any {
  const [form] = Form.useForm();

  const { refreshDepsParams, params, ...p } = options;

  async function getTableData({ current, pageSize }: any, formData: any): Promise<Result> {
    const result = await service(
      noDataFilter({
        ...params,
        pageSize,
        pageIndex: current,
        ...formData,
        ...refreshDepsParams,
      })
    );

    if (result.code === undefined) {
      return {
        list: result.data,
        total: Number(result.pagination.total),
      };
    }
    return {
      total: 0,
      list: [],
    };
  }

  const tableProps = useAntdTable(getTableData, {
    defaultPageSize: 20,
    form,
    ...p,
  });

  return {
    form,
    ...tableProps,
  };
}
